import { faSearch, faClose } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface InputSearchProps {
    placeholder?: string;
    value?: string;
    onChange: (value: string | undefined) => void;
}

export const SearchInput = ({ placeholder, value, onChange }: InputSearchProps) => {

    const handleChange = (e) => {
        onChange(e.target.value);
    }

    const clearInput = () => {
        onChange('');
    }

    // `min-w-0` is not tidying. As a `flex-1` flex item the label's automatic minimum is its
    // content, and an `<input>` reports an intrinsic width from its default `size` — so the field
    // refused to go below ~280px and pushed itself out of any toolbar narrower than that. The
    // store's grid header did exactly that at 768 with the filter panel open.
    return <label className="flex-1 min-w-0 flex flex-row gap-2 items-center border border-white/30 rounded py-2 px-4 focus-within:border-violet-500">
        <FontAwesomeIcon icon={faSearch} className="text-white/30" />
        <input
            type="text"
            placeholder={placeholder ?? 'Search...'}
            className="flex-1 bg-transparent placeholder:text-white/30 focus:outline-none min-w-0"
            autoComplete="off"
            spellCheck={false}
            onChange={handleChange}
            value={value ?? ''}
        />
        <button onClick={clearInput}>
            <FontAwesomeIcon icon={faClose} visibility={!!value ? 'visible' : 'hidden'} />
        </button>
    </label>
}